import _asyncToGenerator from "/home/runner/work/integracao-custos/integracao-custos/frontend/app/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _classCallCheck from "/home/runner/work/integracao-custos/integracao-custos/frontend/app/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js";
import _createClass from "/home/runner/work/integracao-custos/integracao-custos/frontend/app/node_modules/@babel/runtime-corejs2/helpers/createClass.js";
import _regeneratorRuntime from "/home/runner/work/integracao-custos/integracao-custos/frontend/app/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import Vue from "vue";
import authHeader from "./auth-header";
var UserPermissionsService = /*#__PURE__*/function () {
  function UserPermissionsService() {
    _classCallCheck(this, UserPermissionsService);
  }
  return _createClass(UserPermissionsService, [{
    key: "getUserPermissions",
    value: function getUserPermissions(id) {
      return Vue.prototype.$axios.get("/userPermissions/".concat(id), {
        headers: authHeader()
      });
    }
  }, {
    key: "editUserPermission",
    value: function () {
      var _editUserPermission = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(payload) {
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", Vue.prototype.$axios.post('/savePermissions/user', payload, {
                headers: authHeader()
              }));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function editUserPermission(_x) {
        return _editUserPermission.apply(this, arguments);
      }
      return editUserPermission;
    }()
  }, {
    key: "getGsiPermission",
    value: function () {
      var _getGsiPermission = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(payload) {
        return _regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", Vue.prototype.$axios.get('/groupGsPermissions', payload, {
                headers: authHeader()
              }));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function getGsiPermission(_x2) {
        return _getGsiPermission.apply(this, arguments);
      }
      return getGsiPermission;
    }()
  }]);
}();
export default new UserPermissionsService();